import React from 'react'

import SeoParagraphMolecule  from '@/molecules/Paragraphs/SeoParagraph'

const SeoParagraph = (props) => (
  <SeoParagraphMolecule {...props} />
)

export default SeoParagraph
